export default {
  followUpApi: {
    distribution: {
      // 分配相关
      distributionPageList: 'api/followUpDistributionApi/distributionPageList',
      // 回访员列表
      getFollowUpUsers: 'api/followUpDistributionApi/getFollowUpUsers',
      addDistributionRecord: 'api/followUpDistributionApi/addDistributionRecord',
      // 咨询件列表
      consultationPageList: 'api/followUpDistributionApi/consultationPageList',
      // 取消回访
      cancelDistribution: 'api/followUpDistributionApi/cancelDistribution'
    },
    gauging: {
      // 回访员回访
      gaugingPageList: 'api/followUpGaugingApi/gaugingPageList',
      gaugingResult: 'api/followUpGaugingApi/gaugingResult',
      getGauging: 'api/followUpGaugingApi/getGauging',
    },
    result: {
      // 回访结果
      resultPageList: 'api/followUpResultApi/resultPageList',
      getConsultationResult: 'api/followUpResultApi/getConsultationResult',
      exportData: 'api/followUpResultApi/exportResultData'
    }
  }
}